import React, { useReducer, useEffect, useContext, useState, useRef } from 'react';
import {
  Menu,
  Dropdown,
  Button,
  Modal,
  message,
  Form, Row, Col,
  DatePicker,
  Input,
  InputNumber,
  Select,
  Divider,
  Typography,
  Layout
} from 'antd';
import {
  OrderedListOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined,
  CaretDownOutlined,
  InsertRowBelowOutlined,
  CheckCircleOutlined,
  SaveOutlined,
  CloseOutlined,
  CloseCircleOutlined,
  EditOutlined
} from '@ant-design/icons';
import moment from 'moment';
import { Table, Page } from '../../components';
import './style';
import { MasterContext } from '../../App';
import { default as DeliveryNew } from './new';
import { default as DeliveryPalletEdit } from './editPallet';
import { PackageList } from '../'

import { getListEnabled as getBuyerList } from '../../services/Buyer';
import {
  getList,
  getListCount,
  insert,
  insertGoods,
  deleteById,
  getGoodsList,
  updateDeliveryById,
  deleteDeliveryById,
  updateDeliveryDDCFeeById,
  updateDeliveryFeightFeeById,
  updateDeliveryNoById,
  download,
  downloadShipmark,
  deleteDeliveryPackageById,
  deleteDeliveryPalletById
} from '../../services/Delivery';
import { Content } from 'antd/lib/layout/layout';
export default React.forwardRef((props, ref) => {

  const { currentUser, authorities, container, company } = useContext(MasterContext);
  const [form] = Form.useForm();
  const [isShowNew, setShowNew] = useState(false);
  const [isShowEdit, setShowEdit] = useState(false);
  const [isLoadding, setLoadding] = useState(false);
  const [delivery, setDelivery] = useState({});
  const [isShowFee, setShowFee] = useState(false);
  const [fee, setFee] = useState(undefined);
  const [isShowDelivery, setShowDelivery] = useState(false);
  const [keyword, setKeyword] = useState(undefined);
  const [selectedPlan, setSelectedPlan] = useState(undefined);
  const [selectedPalletId, setSelectedPalletId] = useState(undefined);

  const [currentRow, setCurrentRow] = useState({});
  const onSearch = (keyword) => {
    if ((keyword || '').trim().length === 0) setKeyword(undefined);
    else setKeyword(keyword);
  }

  const onClickFee = () => {
    const type = delivery.feeType;
    try {
      const key = 'create_delivery_plan';
      console.log('onClickFee:', type);
      message.loading({ content: '正在新建发货计划...', key });
      if (type === 'ddc') {
        updateDeliveryDDCFeeById(delivery.id, { ddc: fee }).then(() => {
          reload().then(() => {
            setShowFee(false);
            message.success({ content: `新建发货计划成功`, key, duration: 2 });
          });
        });
      } else if (type === 'feight') {
        updateDeliveryFeightFeeById(delivery.id, { feight: fee }).then(() => {
          reload().then(() => {
            setShowFee(false);
            message.success({ content: `新建发货计划成功`, key, duration: 2 });
          });
        });
      } else {
        updateDeliveryNoById(delivery.id, { delivery_no: fee }).then(() => {
          reload().then(() => {
            setShowFee(false);
            message.success({ content: `新建发货计划成功`, key, duration: 2 });
          });
        })
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const [isShowSelectCompany, setShowSelectCompany] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState();
  const handleChangeCompany = (e) => {
    setSelectedCompanyId(e);
  }


  const handleDownload = () => {
    const key = 'create_invoice';
    message.loading({ content: '正在生成Invoice表单...', key, duration: 20 });

    download(currentRow.id, selectedCompanyId ? { company_id: selectedCompanyId } : {}).then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = currentRow.buyer_name.replace('.', '_') + '_' + currentRow.plan_date;
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `Invoid表单下载完成`, key, duration: 2 });
        setShowSelectCompany(false);
      }
    });
  }
  const onEditFeight = (row) => {
    setDelivery(Object.assign({
      feeType: 'feight'
    }, row));
    setShowFee(true);
  }

  const onEditDeliveryNo = (row) => {
    setDelivery(Object.assign({
      feeType: 'deliveryNo'
    }, row));
    setShowFee(true);
  }

  const onEditDDCFee = (row) => {
    setDelivery(Object.assign({
      feeType: 'ddc'
    }, row));
    setShowFee(true);
  }
  const reload = () => {
    var p1 = new Promise((resolve, reject) => {
      getListCount().then(data => {
        dispatch({ type: 'total_rows', data: data });
        resolve(true);
      });
    });

    var p2 = new Promise((resolve, reject) => {
      getList(state.pagination).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    return Promise.all([p1, p2]).then(values => {
    });
  }
  useEffect(() => {
    getBuyerList().then(data => {
      dispatch({ type: 'buyers', data: data });
    });
  }, []);

  const onEditCallback = (id, value) => {
    try {
      const key = 'create_delivery_plan';
      console.log('onEditCallback:', value);
      message.loading({ content: '正在修改发货计划...', key });
      insertGoods(id, value).then((data) => {
        reload().then(() => {
          setShowEdit(false);
          message.success({ content: `修改发货计划成功`, key, duration: 2 });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onNewCallback = (value) => {
    try {
      const key = 'create_delivery_plan';
      console.log('onNewCallback:', value);
      message.loading({ content: '正在新建发货计划...', key });
      insert(value).then((data) => {
        reload().then(() => {
          setShowNew(false);
          message.success({ content: `新建发货计划成功`, key, duration: 2 });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onDeleteDelivery = (id) => {
    try {
      const key = 'create_delivery_plan';
      console.log('onNewCallback:', id);
      message.loading({ content: '正在新建发货计划...', key });
      deleteDeliveryById(id).then((data) => {
        reload().then(() => {
          message.success({ content: `新建发货计划成功`, key, duration: 2 });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }

  const onSave = async (values) => {
    values = await form.validateFields();
    values.loading_date = moment(values.loading_date).format("YYYY-MM-DD");
    values.delivery_date = moment(values.delivery_date).format("YYYY-MM-DD");
    if (values.delivery_date < values.loading_date) {
      Modal.error({
        title: '日期错误',
        content: '发货日期必须晚于铲装日期！',
      });
      return;
    }
    try {
      const key = 'create_delivery_plan';
      console.log('onNewCallback:', values);
      message.loading({ content: '正在更新发货计划...', key });
      updateDeliveryById(values.id, values).then((data) => {
        reload().then(() => {
          setShowDelivery(false);
          message.success({ content: `更新发货计划成功`, key, duration: 2 });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const setPage = (page, pageSize) => {
    dispatch({ type: 'pagination', data: { limit: pageSize, offset: (page - 1) * pageSize } });
  }

  const setSelected = (selected) => {
    dispatch({ type: 'selected', data: selected });
  }

  const initialState = {
    total_rows: 0,
    rows: [],
    sort: { order: 'desc', sort: 'updated' },
    pagination: { limit: 10, offset: 0 },
    views: [],
    buyers: [],
  };
  function reducer(state, action) {
    switch (action.type) {
      case 'buyers':
        return Object.assign({}, state, { buyers: action.data });
      case 'list':
        return Object.assign({}, state, { rows: action.data });
      case 'total_rows':
        return Object.assign({}, state, { total_rows: action.data });
      case 'pagination':
        return Object.assign({}, state, { pagination: action.data });
      case 'packages': {
        const rows = state.rows;
        const obj = rows[action.data.index];
        obj.packages = action.data.packages;
        obj.pallets = action.data.pallets;
        return Object.assign({}, state, { rows: rows });
      }
      case 'selected': {
        const rows = state.rows;
        for (let i = 0; i < rows.length; i++) {
          if ((action.data || []).indexOf(i) > -1) {
            rows[i].selected = true;
          } else {
            rows[i].selected = false;
          }
        }
        return Object.assign({}, state, { rows: rows });
      }
      default:
        throw new Error();
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    setLoadding(true);
    var p1 = new Promise((resolve, reject) => {
      getListCount(keyword).then(data => {
        dispatch({ type: 'total_rows', data: data });
        resolve(true);
      });
    });

    var p2 = new Promise((resolve, reject) => {
      getList(state.pagination, undefined, keyword).then(data => {
        dispatch({ type: 'list', data: data });
        resolve(true);
      });
    });

    Promise.all([p1, p2]).then(values => {
      setLoadding(false);
    });
  }, [state.pagination, keyword]);

  const { rows, total_rows, buyers } = state;
  const onDownloadDelivery = (row) => {
    setSelectedCompanyId();
    setShowSelectCompany(true);
    setCurrentRow(row);
  }

  const onDownloadShipmark = (row, type) => {
    const key = 'create_invoice';
    message.loading({ content: '正在生成唛头表单...', key, duration: 20 });

    downloadShipmark(row.id, type).then(data => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const fileName = row.buyer_name.replace('.', '_') + '_shipmark_' + row.plan_date;
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放 URL对象
        document.body.removeChild(elink);
        message.success({ content: `唛头表单下载完成`, key, duration: 2 });
      }
    });
  }
  const onDeliveryied = (id) => {
    setDelivery(rows.find(x => x.id === id));
    setShowDelivery(true);
  }
  const onBatchDeleteDeliveryPlan = () => {
    const selected = rows.filter(x => x.selected === true);
    showDeleteConfirm(selected)
  }
  const onDeleteDeliveryPlan = (id) => {
    try {
      const key = 'delete_delivery_plan';
      console.log('onDeleteDeliveryPlan:', id);
      message.loading({ content: '正在删除发货计划...', key });
      deleteById(id).then(() => {
        reload().then(() => {
          message.success({ content: `删除发货计划成功`, key, duration: 2 });
        });
      })
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const showDeleteConfirm = (rows) => {
    const content = rows.map(x => (<div>[{x.buyer_name}] :{x.plan_date}</div>))
    Modal.confirm({
      title: '确定取消当前发货计划吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{content}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDeleteDeliveryPlan(rows.map(x => x.id));
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const showCancelDeliveryConfirm = (rows) => {
    const content = rows.map(x => (<div>[{x.buyer_name}] :{x.delivery_date}</div>))
    Modal.confirm({
      title: '确定撤销当前实际发货吗?',
      icon: <ExclamationCircleOutlined />,
      content: <strong>{content}</strong>,
      okText: 'Yes',
      centered: true,
      okType: 'danger',
      cancelText: 'No',
      onOk() {
        onDeleteDelivery(rows.map(x => x.id))
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const editPallet = (i, id, plan) => {
    setSelectedPlan(plan);
    setSelectedPalletId(id);
    setShowEdit(true)
  }
  const downloadMenu = (row) => {
    return <Menu >
      {
        (authorities.find(x => x === 'download_invoice') || currentUser.category_id === 1) &&
        <Menu.Item key="1">
          <Button onClick={() => onDownloadDelivery(row)} type="link" icon={<OrderedListOutlined />}>Invoice表单【3联】</Button>
        </Menu.Item>
      }
      <Menu.Item key="2">
        <Button onClick={() => onDownloadShipmark(row, 0)} type="link" icon={<InsertRowBelowOutlined />}>托盘唛头 (标准)</Button>
      </Menu.Item>
      <Menu.Item key="3">
        <Button onClick={() => onDownloadShipmark(row, 1)} type="link" icon={<InsertRowBelowOutlined />}>托盘唛头 (无产品名称)</Button>
      </Menu.Item>
    </Menu>;
  }
  const Expandable = (row, index) => {
    if (!row.packages && !row.pallets) {
      getGoodsList(row.id).then(packages => {
        const pallets = [];
        packages.forEach(x => {
          x.weight = x.count * x.unit_weight * 0.001;
          if (x.pallet_id > 0) {
            if (!pallets.find(y => y.id === x.pallet_id)) {
              pallets.push({ id: x.pallet_id });
            }
          }
        })
        dispatch({ type: 'packages', data: { index, packages, pallets } })
      });
    }
    return (
      <div style={{ margin: '-1px -1px 0 -1px', padding: '1rem 3rem', border: '1px solid #c0c0c0', backgroundColor: 'RGB(252, 240, 200)' }}>
        <PackageList
          data={row}
          reload={reload}
          readOnly={row.delivery_date != undefined}
          deliveryId={row.id}
          editPallet={editPallet}
          deletePallet={deleteDeliveryPalletById}
          deletePackage={deleteDeliveryPackageById}
        />
      </div>
    )
  }

  let initValue = [
    { name: ['id'], value: delivery.id },
    { name: ['buyer_name'], value: delivery.buyer_name },
    { name: ['buyer_name_nick'], value: delivery.buyer_name_nick },
    { name: ['buyer'], value: '[' + delivery.buyer_name_nick + '] - ' + delivery.buyer_name },
    { name: ['plan_date'], value: delivery.plan_date },
    { name: ['loading_date'], value: delivery.loading_date && moment(delivery.loading_date, 'YYYY-MM-DD') },
    { name: ['delivery_date'], value: delivery.delivery_date && moment(delivery.delivery_date, 'YYYY-MM-DD') },
    { name: ['remark'], value: delivery.remark },
    { name: ['container_sn'], value: delivery.container_sn }
  ];

  const deliveriedBody = (
    <Form style={{ padding: '1rem 1rem' }} form={form} preserve={false} onFinish={onSave} fields={initValue} >
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Form.Item name="buyer" label="客户名称" rules={[{ required: true, message: '' }]}>
            <Input disabled />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Form.Item name="plan_date" label="计划日期" rules={[{ required: true, message: '' }]}>
            <Input disabled />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Form.Item name="loading_date" label="铲装日期" rules={[{ required: true, message: '请输入铲装日期!' }]}>
            <DatePicker format="YYYY-MM-DD" placeholder="请选择铲装日期" style={{ width: '100%' }} />
          </Form.Item>
          <Form.Item hidden={true} name="id">
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Form.Item name="delivery_date" label="发货日期" rules={[{ required: true, message: '请输入发货日期!' }]}>
            <DatePicker format="YYYY-MM-DD" placeholder="请选择发货日期" style={{ width: '100%' }} />
          </Form.Item>
        </Col>
      </Row>
      {/* <Row gutter={[8, 8]}>
        <Col span={24}>
          <Form.Item label="发货集装箱序列号" name="container_sn" >
            <Input
              onChange={null}
              placeholder="请输入发货集装箱序列号"
            />
          </Form.Item>
        </Col>
      </Row> */}
      <Row gutter={[8, 8]}>
        <Col span={24}>
          <Form.Item label="　发货备注" name="remark" >
            <Input.TextArea
              placeholder="请输入备注"
              autoSize={{ minRows: 2, maxRows: 2 }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <div style={{ width: '100%', paddingRight: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={() => setShowDelivery(false)} icon={<CloseOutlined />}>关 闭</Button>
            &nbsp;&nbsp;
            <Button htmlType="submit" type="primary" icon={<SaveOutlined />}>保存</Button>
          </div>
        </Col>
      </Row>
    </Form>
  );

  return (
    <div style={{ padding: '0.5rem 1.5rem' }}  >

      <Table
        showFilter={true}
        onSearch={onSearch}
        onSearchPlaceHolder="请输入客户名称、港口名称或发票号"
        searchWidth="360px"
        setSelectedCallback={setSelected}
        setPageCallback={setPage}
        isLoadding={isLoadding}
        expandable={true}
        expand={Expandable}
        hasCheckbox={true}
        title="发货计划管理"
        newLabel={"新建发货计划"}
        showNewLabel={authorities.find(x => x === 'create_order') || currentUser.category_id === 1}
        showFooter={true}
        rows={rows}
        total_rows={total_rows}
        onNew={() => setShowNew(!isShowNew)}
        header={[
          { label: '计划日期', width: '110px', item: 'plan_date', align: 'center' },
          { label: '目标港口', width: '120px', item: 'destination_port_name', align: 'center' },
          {
            label: '客户名称', item: 'buyer_name', align: 'left', render: (text, row, index) => {
              return <span>[{row.buyer_name_nick}] {row.buyer_name}</span>
            }
          },
          // { label: '类型', width: '50px', item: 'delivery_type_name', align: 'center' },
          { label: '托数', width: '60px', align: 'right', item: 'pallet_count' },
          { label: '散箱', width: '60px', align: 'right', item: 'carton_count' },
          {
            label: '到港提货费', width: '90px', align: 'right', item: 'ddc', render: (item, row, index) => {
              return <div>
                <span style={{ paddingRight: '0.25rem' }}>{item}</span>
                {!row.delivery_date && <Button onClick={() => onEditDDCFee(row)} type="link" size="small" icon={<EditOutlined />}></Button>}
              </div>
            }
          },
          {
            label: '运费', width: '90px', align: 'right', item: 'feight', render: (item, row, index) => {
              return <div>
                <span style={{ paddingRight: '0.25rem' }}>{item}</span>
                {!row.delivery_date && <Button onClick={() => onEditFeight(row)} type="link" size="small" icon={<EditOutlined />} ></Button>}
              </div>
            }
          },
          {
            label: '发票号', width: '165px', align: 'center', item: 'delivery_no', render: (item, row, index) => {
              return <div>
                <span style={{ paddingRight: '0.25rem' }}>{item}</span>
                {!row.delivery_date && <Button onClick={() => onEditDeliveryNo(row)} type="link" size="small" icon={<EditOutlined />} ></Button>}
              </div>
            }
          },
          { label: '铲装日期', width: '110px', align: 'center', item: 'loading_date' },
          { label: '实发日期', width: '110px', align: 'center', item: 'delivery_date' },
          {
            label: '操作', width: '260px', align: 'center', item: '-', render: (item, row, index) => {
              return <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'space-around' }}>
                {!row.delivery_date && <Button danger onClick={() => showDeleteConfirm([row])} size="small" icon={<DeleteOutlined />}>删除计划</Button>}
                &nbsp;&nbsp;
                <Dropdown.Button size="small" overlay={downloadMenu(row)} style={{ backgroundColor: '#f0f0f0f' }} icon={<CaretDownOutlined />} >
                  <DownloadOutlined />
                  下载票据
                </Dropdown.Button>
                &nbsp;&nbsp;
                {!row.delivery_date && <Button type="primary" onClick={() => onDeliveryied(row.id)} size="small" icon={<CheckCircleOutlined />}>发货</Button>}
                &nbsp;&nbsp;
                {row.delivery_date && <Button type="primary" danger onClick={() => showCancelDeliveryConfirm([row])} icon={<CloseCircleOutlined />} size="small">撤销发货</Button>}
              </div>
            }
          }
        ]}
        bordered={true} />
      <Page
        title="新建发货计划"
        isMaximize={true}
        onCloseCallback={() => setShowNew(!isShowNew)}
        body={<DeliveryNew mode="new" company={company} container={container} buyers={buyers} onSaveCallback={onNewCallback} onCloseCallback={() => setShowNew(!isShowNew)} />}
        visible={isShowNew}
      />
      <Page
        title="完成实际发货"
        onCloseCallback={() => setShowDelivery(false)}
        body={deliveriedBody}
        visible={isShowDelivery}
      />
      <Page
        title={`请输入${delivery.feeType === 'deliveryNo' ? '发票号' : delivery.feeType + '费用'}`}
        onCloseCallback={() => setShowFee(false)}
        body={<div style={{ padding: '1.5rem 2rem' }}>
          {delivery.feeType !== 'deliveryNo' && <InputNumber style={{ width: '80%' }} onChange={setFee} min={0} />}
          {delivery.feeType === 'deliveryNo' && <Input style={{ width: '80%' }} onChange={(e) => setFee(e.target.value)} />}
          <Button style={{ width: '20%' }} type="primary" onClick={onClickFee}>确定</Button></div>}
        visible={isShowFee}
      />
      <Page
        title="修改托盘"
        isMaximize={true}
        onCloseCallback={() => setShowEdit(!isShowEdit)}
        body={<DeliveryPalletEdit palletId={selectedPalletId} plan={selectedPlan} onSaveCallback={onEditCallback} onCloseCallback={() => setShowEdit(false)} />}
        visible={isShowEdit}
      />

      <Page
        title='选择表单中显示的业务公司?'
        isMaximize={false}
        visible={isShowSelectCompany}
        onCloseCallback={() => setShowSelectCompany(!isShowSelectCompany)}
        body={
          <Content style={{ padding: '1rem' }}>
            Invoice当前默认的业务公司：<br /><Typography.Link strong>{company.find(c => c.id === buyers.find(x => x.id === currentRow.buyer_id)?.company_id)?.name_cn}</Typography.Link><br />
            <Divider />
            选择其他业务公司：<Select style={{ width: '100%' }} onChange={handleChangeCompany} defaultValue={selectedCompanyId}>
              {
                company.filter(c => c.id !== buyers.find(x => x.id === currentRow.buyer_id)?.company_id).map(x => {
                  return <Select.Option key={'selectcompany-' + x.id} value={x.id}>{x?.name_cn}</Select.Option>
                })
              }
            </Select>

            <Divider />
            <div style={{ display: 'flex', justifyContent: 'end' }}>
              <Button>取消</Button>&nbsp;&nbsp;&nbsp;
              <Button type='primary' onClick={handleDownload}>下载</Button>
            </div>
          </Content>
        }
      />
      <Page
        title='选择表单中显示的业务公司?'
        isMaximize={false}
        visible={isShowSelectCompany}
        onCloseCallback={() => setShowSelectCompany(!isShowSelectCompany)}
        body={
          <Content style={{ padding: '1rem' }}>
            当前默认的业务公司：<br /><Typography.Link strong>{company.find(c => c.id === buyers.find(x => x.id === currentRow.buyer_id)?.company_id)?.name_cn}</Typography.Link><br />
            <Divider />
            选择其他业务公司：<Select allowClear={true} style={{ width: '100%' }} onChange={handleChangeCompany} defaultValue={selectedCompanyId}>
              {
                company.filter(c => c.id !== buyers.find(x => x.id === currentRow.buyer_id)?.company_id).map(x => {
                  return <Select.Option key={'selectcompany-' + x.id} value={x.id}>{x?.name_cn}</Select.Option>
                })
              }
            </Select>

            <Divider />
            <div style={{ display: 'flex', justifyContent: 'end' }}>
              <Button onClick={() => setShowSelectCompany(false)}>取消</Button>&nbsp;&nbsp;&nbsp;
              <Button type='primary' onClick={handleDownload}>下载</Button>
            </div>
          </Content>
        }
      />
    </div>
  );
});
